import { AuthGuard } from './../../_guards/auth.guard';
import { SelectionGenericComponent } from './selection-generic.component';


import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


const routes: Routes = [
    {
            path: '',
            component: SelectionGenericComponent,
            canActivate: [AuthGuard],
    },
]; 

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SelectionGenericRoutingModule { }
